import { useId } from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";
import {
  APAC_FORM_UI_NAME,
  ApacFormUiComponent,
  FormInputWrapper,
} from "@apac/form-ui";
import { useModuleBEM, useStyles } from "@b2bportal/core-themes";
import { Select, SelectItem } from "@tenant/ui";
import defaultStyles from "./styles.module.scss";

export interface SelectFieldProps {
  formContext: UseFormReturn<FieldValues, unknown, undefined>;
  className?: string;
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  defaultValue?: string;
  options: Array<{
    key?: string;
    value: string;
    label: string;
    icon?: React.ReactNode;
  }>;
}

export const SelectField: React.FC<SelectFieldProps> = (props) => {
  const { formContext, options, placeholder = "", defaultValue } = props;

  const styles = useStyles(
    APAC_FORM_UI_NAME,
    ApacFormUiComponent.SelectField,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, ApacFormUiComponent.SelectField);

  // Associate the visible label with the Select's trigger button via htmlFor/id (WCAG 1.3.1 / 4.1.2).
  const inputId = useId();

  return (
    <div className={block}>
      <FormInputWrapper
        {...props}
        htmlFor={inputId}
        control={formContext.control}
        render={({ field }) => {
          return (
            <Select
              {...field}
              id={inputId}
              className={cn("trigger")}
              placeholder={placeholder}
              onValueChange={field.onChange}
              defaultValue={defaultValue || field.value}
            >
              {options.map((item, index) => {
                return (
                  <SelectItem
                    key={item.key || `${item.value}-${index}`}
                    value={item.value}
                  >
                    <span className={cn("item")}>
                      {item.label}

                      {item.icon}
                    </span>
                  </SelectItem>
                );
              })}
            </Select>
          );
        }}
      />
    </div>
  );
};
